"use client"

import {ActionIcon, Container, Group, rem, Text} from '@mantine/core';
import classes from './FooterLinks.module.css';
import Image from "next/image";
import React from "react";
import cx from "clsx";
import {IconBrandInstagram, IconBrandTwitter, IconBrandYoutube} from "@tabler/icons-react";
import {notoSerifTC} from "@/styles/fonts";

const data = [
    {
        title: '最新消息',
        links: [
            { label: '[最新消息.1]', link: '#' },
            { label: '[最新消息.2]', link: '#' },
            { label: '[最新消息.3]', link: '#' },
            { label: '[最新消息.4]', link: '#' },
        ],
    },
    {
        title: '網站介紹',
        links: [
            { label: '[網站介紹.1]', link: '#' },
            { label: '[網站介紹.2]', link: '#' },
            { label: '[網站介紹.3]', link: '#' },
            { label: '[網站介紹.4]', link: '#' },
        ],
    },
    {
        title: '相關文件',
        links: [
            { label: '[相關文件.1]', link: '#' },
            { label: '[相關文件.2]', link: '#' },
            { label: '[相關文件.3]', link: '#' },
            { label: '[相關文件.4]', link: '#' },
        ],
    },
];

export function FooterLinks() {
    const groups = data.map((group) => {
        const links = group.links.map((link, index) => (
            <Text<'a'>
                key={index}
                className={classes.link}
                component="a"
                href={link.link}
                onClick={(event) => event.preventDefault()}
            >
                {link.label}
            </Text>
        ));

        return (
            <>
                <div className={classes.wrapper} key={group.title}>
                    <Text className={classes.title}>{group.title}</Text>
                    {links}
                </div>
            </>
        );
    });


    return (
        <footer className={classes.footer}>
            <div className="flex justify-between max-w-[1200px] mx-auto">
                <div className={classes.logo}>
                    <Image
                        src="/tcc-logo.png"
                        alt="tcc icon"
                        width={320}
                        height={50}
                    />
                </div>
                {/*<div className={classes.groups}>{groups}</div>*/}

                <div className={cx("flex flex-col gap-1 text-gray-600 text-sm", notoSerifTC.className)}>
                    <div>指導單位 | 國家科學及技術委員會</div>
                    <div>執行單位 | 財團法人國家實驗研究院科技政策研究與資訊中心</div>
                    <div>地址：(10636) 台北市和平東路二段 106 號 1,14～15 樓</div>
                </div>
            </div>


            {/*<Container className={classes.afterFooter}>*/}
            {/*    <Text c="dimmed" size="sm">*/}
            {/*        © 2020 mantine.dev. All rights reserved.*/}
            {/*    </Text>*/}

            {/*    <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap">*/}
            {/*        <ActionIcon size="lg" color="gray" variant="subtle">*/}
            {/*            <IconBrandTwitter style={{ width: rem(18), height: rem(18) }} stroke={1.5} />*/}
            {/*        </ActionIcon>*/}
            {/*        <ActionIcon size="lg" color="gray" variant="subtle">*/}
            {/*            <IconBrandYoutube style={{ width: rem(18), height: rem(18) }} stroke={1.5} />*/}
            {/*        </ActionIcon>*/}
            {/*        <ActionIcon size="lg" color="gray" variant="subtle">*/}
            {/*            <IconBrandInstagram style={{ width: rem(18), height: rem(18) }} stroke={1.5} />*/}
            {/*        </ActionIcon>*/}
            {/*    </Group>*/}
            {/*</Container>*/}
        </footer>
    );
}
